import axios from 'axios'

export default {
    namespaced: true,
    state: {
        states: [],
        status_array: [],
        job_status_array: [],
        roles: [],
        counties: [],
        sizes: [],
        options: [],
		preffered_time: [],
		preffered_contact: [],
        how_did_hear: [],
        leads: [],
        estimators: [],
        schedules_array: [],
        confirmations_array: [],
        assign_array: [],
        users: [],
        contact_email: '',
        contact_phone: ''
    },
    getters: {
        states (state) {
            return state.states
        },
        statusArray (state) {
            return state.status_array
        },
        jobStatusArray (state) {
            return state.job_status_array
        },
        roles (state) {
            return state.roles
        },
        counties (state) {
            return state.counties
        },
        sizes (state) {
            return state.sizes
        },
        options (state) {
            return state.options
        },
        filteredOptions (state) {
            return state.options.filter(option => {
                return option.required != "Yes"
            })
        },
        requiredOptions (state) {
            return state.options.filter(option => {
                return option.required == "Yes"
            })
        },
        requiredTotal (state) {
            var sum = 0
            state.options.forEach(option => {
                if(option.required == 'Yes')
                    sum += parseFloat(option.price)
            });
            return sum
        },
		preffered_time (state) {
			return state.preffered_time
		},
		preffered_contact (state) {
			return state.preffered_contact
		},
		how_did_hear (state) {
			return state.how_did_hear
        },
        leads (state) {
            return state.leads
        },
        estimators (state) {
            return state.estimators
        },
        schedulesArray (state) {
            return state.schedules_array
        },
        confirmationsArray (state) {
            return state.confirmations_array
        },
        assignArray (state) {
            return state.assign_array
        },
        users (state) {
            return state.users
        },
        contact_email (state) {
            return state.contact_email
        },
        contact_phone (state) {
            return state.contact_phone
        },
    },
    mutations: {
        SET_STATES(state, payload) {
            state.states = payload
        },
        SET_STATUS_ARR(state, payload) {
            return state.status_array = payload
        },
        SET_JOB_STATUS_ARR(state, payload) {
            return state.job_status_array = payload
        },
        SET_ROLES(state, payload) {
            return state.roles = payload
        },
        SET_COUNTIES(state, payload) {
            state.counties = payload
        },
        SET_SIZES(state, payload) {
            state.sizes = payload
        },
        SET_OPTIONS(state, payload) {
            state.options = payload
        },
        SET_PREFFRED(state, payload) {
            return state.preffered_time = payload
		},
        SET_PREFFRED_CONTACT(state, payload) {
            return state.preffered_contact = payload
		},
        SET_HOW(state, payload) {
            return state.how_did_hear = payload
        },
        SET_LEADS(state, payload) {
            return state.leads = payload
        },
        SET_ESTIMATORS(state, payload) {
            return state.estimators = payload
        },
        SET_SCHEDULES_ARR(state, payload) {
            return state.schedules_array = payload
        },
        SET_CONFIRMATION_ARR(state, payload) {
            return state.confirmations_array = payload
        },
        SET_ASSIGN_ARR(state, payload) {
            return state.assign_array = payload
        },
        SET_USERS(state, payload) {
            return state.users = payload
        },
        SET_CONTACT_EMAIL(state, payload) {
            return state.contact_email = payload
        },
        SET_CONTACT_PHONE(state, payload) {
            return state.contact_phone = payload
        },
    },
    actions: {
        async getData({ commit }) {
            let response = await axios.post('crmcustomer/data')
            commit('SET_STATES', response.data.data.states)     
            commit('SET_STATUS_ARR', response.data.data.status_array)
            commit('SET_JOB_STATUS_ARR', response.data.data.job_status_array)
            commit('SET_ROLES', response.data.data.roles)
            commit('SET_NEW_COUNT', response.data.data.new_count)
            commit('SET_ALL_COUNT', response.data.data.total_count)
            commit('SET_COUNTIES', response.data.data.counties)
            commit('SET_SIZES', response.data.data.sizes)
            commit('SET_OPTIONS', response.data.data.options)
            commit('SET_PREFFRED', response.data.data.preffered_time)
            commit('SET_PREFFRED_CONTACT', response.data.data.preffered_contact)
            commit('SET_HOW', response.data.data.how_did_hear)
            commit('SET_ESTIMATORS', response.data.data.estimators)        
            commit('SET_SCHEDULES_ARR', response.data.data.schedules_array)
            commit('SET_CONFIRMATION_ARR', response.data.data.confirmations_array)
            commit('SET_ASSIGN_ARR', response.data.data.assign_array)
            commit('SET_USERS', response.data.data.users)
            commit('SET_CONTACT_EMAIL', response.data.data.contact_email)
            commit('SET_CONTACT_PHONE', response.data.data.contact_phone)
        },
        async updateCustomer( { dispatch }, data) {
            let response = await axios.post('crmcustomer/update', data)
            await dispatch('getData')
            return response.data
        },
        async addComment(_, data) {
            let response = await axios.post('crmcustomer/job_comment', data)        
            return response.data
        },
    }
}